module.exports = "<div class=\"small modal-container\" ng-show=\"versionServ.update\">\n    <div class=\"grid\">\n        <div class=\"grid-item nav-item-text\">\n            <b>FactBox update available</b>\n        </div>\n        <div class=\"grid-item-fixed\">\n            <div class=\"btn text-action\" ng-click=\"reload()\">Reload</div>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./project/directives/lf-update-notification/lf-update-notification.html
// module id = 838
// module chunks = 3